module.exports = __webpack_public_path__ + "static/media/15UN-Habitat6.8d5ce73d.jpg";